import queryString from 'query-string';
import React from 'react';
// @ts-expect-error ts-migrate(2305) FIXME: Module '"react-router"' has no exported member 'Ro... Remove this comment to see the full error message
import { RouterHistory } from 'react-router';

import { CurrentUser } from 'api/currentUser';
import { TileCarousel } from 'components/TileCarousel';
import { JobFunction } from 'utils/constants';
import { listingSearchHomePath } from 'utils/searchHomePages';

import { useCarouselRecommendedJobs } from './useCarouselRecommendedJobs';

type StandardCmsRecommendedJobsProps = {
  headline: string;
  layout: 'SLIM' | 'REGULAR';
  jobFunction: JobFunction | null | undefined;
  source: 'RECOMMENDED_JOBS_CHECKBOX' | 'RECOMMENDED_JOBS_BLOCK';
  currentUser: CurrentUser | null | undefined;
  history: RouterHistory;
};
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
export const StandardCmsRecommendedJobs = ({
  headline,
  layout,
  jobFunction,
  currentUser,
  history,
  source,
}: StandardCmsRecommendedJobsProps) => {
  const recommendedJobs = useCarouselRecommendedJobs({
    currentUser,
    options: {
      onlyWithLogo: layout === 'REGULAR',
      jobFunction,
    },
  });
  if (!recommendedJobs) return null;
  const seeAllQueryString = queryString.stringify(
    {
      searchMode: true,
      q: '',
      functions: [jobFunction],
    },
    {
      skipNull: true,
    }
  );
  const additionalAnalyticsProps = {};
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'job_function' does not exist on type '{}... Remove this comment to see the full error message
  if (jobFunction) additionalAnalyticsProps.job_function = jobFunction;
  return (
    <TileCarousel
      headline={headline}
      results={recommendedJobs}
      // @ts-expect-error ts-migrate(2322) FIXME: Type '{ headline: string; results: TileCarouselRes... Remove this comment to see the full error message
      history={history}
      seeAllText={
        /* TRANSLATORS: Link to job search */
        getText('See all jobs')
      }
      seeAllUrl={`${listingSearchHomePath('JOB')}?${seeAllQueryString}`}
      listingType="JOB"
      carouselLocation="CMS Page"
      layout={layout}
      source={source}
      additionalAnalyticsProps={additionalAnalyticsProps}
    />
  );
};
